/* Hitrejsi obcutek navigacije na strani shem (/pages/tomos-*):
   klik na povezavo -> takojsnja bela plast z vrtavko cez trenutno stran ("app-shell" obcutek),
   dokler brskalnik ne izrise nove strani. (Ogrevalni fetch ob hoverju je odstranjen, glej spodaj.)
   Datoteka je samostojna in izbrisljiva; vkljucena v layout/theme.liquid. */
(function () {
  var MATCH = '/pages/tomos-';

  function shemaLink(el) {
    var a = el && el.closest ? el.closest('a[href]') : null;
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    return href.indexOf(MATCH) !== -1 ? a : null;
  }

  /* (1) Ogrevalni fetch ob hoverju je odstranjen (avg 2026): odgovor /pages/tomos-* nima cache glav
     (cf-cache-status DYNAMIC, Vary: Accept), zato ga navigacija NIKOLI ne dobi iz predpomnilnika —
     hover je le prenesel ~90 kB (695 kB dekodirano) v prazno. Povezava na sheme je zdaj tudi v kartici
     "Kje je ta del na motorju?" na vsaki strani Tomos izdelka, kjer bi to stalo ob vsakem prehodu miske. */

  /* 2) takojsnji loading overlay ob kliku — prekrije SAMO vsebino pod headerjem.
     Header trenutne strani ostane viden (na vseh straneh je enak), zato je videti,
     kot da stoji ves cas, spodaj pa se nalaga — brez "utripa" cele strani. */
  function headerBottom() {
    var hdr = document.querySelector('header.header') ||
              document.querySelector('.shopify-section header') ||
              document.querySelector('header');
    if (!hdr) return 0;
    var r = hdr.getBoundingClientRect();
    /* ce je header zaradi scrolla izven zaslona, prekrij vse od vrha */
    return Math.max(0, Math.min(r.bottom, window.innerHeight * 0.5));
  }

  function buildOverlay() {
    var top = headerBottom();
    var d = document.createElement('div');
    d.id = 'shema-nav-overlay';
    d.innerHTML =
      '<style>' +
      /* enotna prosojna sivina cez celo stran (lovi tudi klike); vrtavka na beli kartici */
      '#shema-nav-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(33,41,52,.34);animation:sno-fade .2s ease;display:flex;align-items:flex-start;justify-content:center}' +
      '#shema-nav-overlay .sno-card{margin-top:' + (top + 90) + 'px;background:#fff;border-radius:14px;box-shadow:0 10px 40px rgba(0,0,0,.25);padding:26px 34px;display:flex;flex-direction:column;align-items:center;gap:14px}' +
      '#shema-nav-overlay .sno-spin{width:46px;height:46px;border:4px solid #e4e8ee;border-top-color:#0768ce;border-radius:50%;animation:sno-spin .8s linear infinite}' +
      '@keyframes sno-spin{to{transform:rotate(360deg)}}' +
      '@keyframes sno-fade{from{opacity:0}}' +
      '#shema-nav-overlay p{color:#3a4450;font-size:16px;font-weight:600;margin:0}' +
      '</style>' +
      '<div class="sno-card"><div class="sno-spin" aria-hidden="true"></div>' +
      '<p>Nalaganje shem &hellip;</p></div>';
    return d;
  }

  function removeOverlay() {
    var o = document.getElementById('shema-nav-overlay');
    if (o) o.remove();
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = shemaLink(e.target);
    if (!a) return;
    if (a.target && a.target !== '_self') return; /* nova zavihka ne prekrivamo */
    if (!document.getElementById('shema-nav-overlay')) {
      document.body.appendChild(buildOverlay());
      /* varovalka: ce navigacija odpove (offline ipd.), plast ne sme obviseti */
      setTimeout(removeOverlay, 15000);
    }
  }, true);

  /* bfcache: ob vrnitvi z "nazaj" plast takoj stran */
  window.addEventListener('pageshow', removeOverlay);
})();
